import {API, CUSTOMER_API} from "../actionTypes";
import {apiError, apiStart} from "../actions";
import $ from "jquery"
import {getProductsTotalSum} from "../selectors";

const customerAPI = store => next => action => {
    next(action);

    let dispatch = store.dispatch;
    let state = store.getState();

    if (action.type !== CUSTOMER_API) return;

    if(action.payload.request === 'simulateMemberPoints'){
        oneLoyaltySimulateRequest(store).then(action.payload.onSuccess, action.payload.onFailure);
        return;
    }else if(action.payload.request === 'setMemberMarketingConsent'){
        setMemberMarketingConsentRequest(store, action.payload).then(action.payload.onSuccess, action.payload.onFailure);
        return;
    }

    const {
        request,
        method = "GET",
        data,
        onSuccess,
        onFailure,
        label
    } = action.payload;

    if (label) {
        dispatch(apiStart(label));
    }

    if(process.env.REACT_APP_ERPLY_MODE === "1"){
        sendErplyRequest(request, data, state, dispatch, onSuccess, onFailure);
    }else{
        sendExternalRequest(request, method, data, state, dispatch, onSuccess, onFailure, store);
    }

};

const sendErplyRequest = (request, data, state, dispatch, onSuccess, onFailure) => {
    dispatch({
        type: API,
        payload: {
            data: {
                ...data,
                request
            },
            onSuccess,
            onFailure,
            label: request
        }
    });
};

const sendExternalRequest = (request, method, data, state, dispatch, onSuccess, onFailure, store) => {
    let countryCode = state.rootReducer.erplyConf.DKTCountryCode;

    let params = JSON.stringify(data);

    let requestData = {
        params,
        countryCode
    }
    if(window.AppConf.preprod){
        requestData.preProdCountryCode = requestData.countryCode;
        requestData.countryCode = 'preprod';
    }
    const url = window.AppConf.CustomerAPI.url;
    const failMessage = 'Could not connect to customer database!';
    $.ajax({
        url: url + '/' + request,
        type: method,
        crossDomain: true,
        data: requestData,
        timeout: 10000,
        success: function(data){
            try {
                let result = JSON.parse(data);
                if(result.status.responseStatus === 'ok' && result.data.customers !== null){
                    console.log('CAP: successful API request!', result);
                    dispatch(onSuccess(result.data.customers));
                }else{
                    console.log('CAP: Customer API request failed!', result);
                    dispatch(onFailure(result, store.getState));
                }
            }catch (e) {
                console.log('CAP: Customer API request failed! Could not parse: ', data);
                dispatch(onFailure({
                    failMessage: failMessage,
                    textStatus: "error",
                    errorThrown: "Could not parse response"
                }, store.getState));
            }
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.log('CAP: Customer API request failed!', failMessage, textStatus);
            dispatch(onFailure({
                failMessage: failMessage,
                textStatus: textStatus,
                errorThrown: errorThrown
            }, store.getState));
            dispatch(apiError(failMessage, false));
        }
    });
};

export const oneLoyaltySimulateRequest = (store) => {
    return new Promise((resolve, reject) => {
        let state = store.getState();
        let amount = getProductsTotalSum(state.rootReducer.productsInBasket);
        let currency = state.rootReducer.erplyConf.default_currency
        let saleItems = state.rootReducer.productsInBasket.reduce((acc, el) => {
            acc.push({
                id: el.data.productID,
                amount: el.rowTotal,
                quantity: el.amount
            });
            return acc;
        }, []);
        let data = {
            interaction_type: "purchase",
            amount,
            currency: {
                currency
            },
            saleItems
        };

        let requestData = {
            details: JSON.stringify(data),
            countryCode: state.rootReducer.erplyConf.DKTCountryCode
        }
        const url = window.AppConf.CustomerAPI.url;
        const failMessage = 'Could not connect to customer database!';
        $.ajax({
            url: url + '/loyaltySimulate',
            type: 'POST',
            crossDomain: true,
            data: requestData,
            timeout: 10000,
            success: (data) => {
                try {
                    let result = JSON.parse(data);
                    if(result.status.responseStatus === 'ok'){
                        resolve(result.data);
                    }else{
                        reject(data);
                    }
                }catch (e) {
                    reject("Could not parse response");
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                store.dispatch(apiError(failMessage, false));
                reject(textStatus);
            }
        });
    });
}

export const setMemberMarketingConsentRequest = (store, payload) => {
    return new Promise((resolve, reject) => {
        let state = store.getState();
        let requestData = {
            memberId: payload.memberId,
            enabled: payload.enabled ? '1' : '0',
            countryCode: state.rootReducer.erplyConf.DKTCountryCode
        }
        if(window.AppConf.preprod){
            requestData.preProdCountryCode = requestData.countryCode;
            requestData.countryCode = 'preprod';
        }
        const url = window.AppConf.CustomerAPI.url;
        const failMessage = 'Could not connect to customer database!';
        $.ajax({
            url: url + '/setMemberMarketingConsent',
            type: 'POST',
            crossDomain: true,
            data: requestData,
            timeout: 10000,
            success: (data) => {
                try {
                    let result = JSON.parse(data);
                    if(result.status.responseStatus === 'ok'){
                        resolve(result.data);
                    }else{
                        reject(data);
                    }
                }catch (e) {
                    reject("Could not parse response");
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                store.dispatch(apiError(failMessage, false));
                reject(textStatus);
            }
        });
    });
}
export default customerAPI;
